import { gql } from '@apollo/client'

export const SAVE_ATTACK = gql`
  mutation createOrUpdateAttack($input: AttackInput!) {
    createOrUpdateAttack(input: $input) {
      id
    }
  }
`
export const SAVE_ATTACK_BY_GUID = gql`
  mutation saveAttackByGuid($input: AttackInput!) {
    updateAttackByGuid(input: $input) {
      id
    }
  }
`
export const DELETE_ATTACK_BY_GUID = gql`
  mutation deleteAttackByGuid($id: String!) {
    deleteAttackByGuid(id: $id)
  }
`

export const RECALCULATE_ATTACK_BY_GUID = gql`
  mutation recalculateAttackByGuid($id: String!) {
    recalculateAttackByGuid(id: $id) {
      id
      name
      geojson
      start_speed
      end_speed
      path_length
      vehicle
      start_lat
      start_lon
      end_lat
      end_lon
      end_direction
      geom_guid
      original_id
    }
  }
`

export const RECALCULATE_ATTACK_LS = gql`
  mutation recalculateAttackLS($input: RecalculateInput!) {
    recalculateAttackLS(input: $input) {
      id
      name
      geojson
      start_speed
      end_speed
      path_length
      vehicle
      start_lat
      start_lon
      end_lat
      end_lon
      end_direction
      geom_guid
      original_id
      all_vehicle_data
    }
  }
`
